import { Fab, makeStyles } from "@material-ui/core"
import CloudIcon from '@material-ui/icons/Cloud';

const useStyles = makeStyles((theme) => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    fab: {
        position: 'fixed',
        zIndex: 1000,
        bottom: theme.spacing(2),
        right: theme.spacing(2),
        textTransform: 'capitalize'
    },
    extendedIcon: {
      marginRight: theme.spacing(1),
    },
  }));

export const LearnLLMButton = ({onClick, disabled}) => {
    const classes = useStyles();

    return(
        <Fab 
            variant="extended" 
            size="medium"
            color="light"
            aria-label="add"
            className={classes.fab}
            onClick={onClick}
            disabled={disabled}
        >
            <CloudIcon className={classes.extendedIcon}  />
            Feed LLM
        </Fab>  
    )
}